import React from 'react';

var XFilledIcon = function XFilledIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "16",
    height: "16",
    role: "img",
    style: {
      display: "block",
      margin: "0 auto",
      fill: "rgb(102,102,102)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.343 13.657A8 8 0 1 1 13.658 2.343 8 8 0 0 1 2.343 13.657ZM6.03 4.97a.751.751 0 0 0-1.042.018.751.751 0 0 0-.018 1.042L6.94 8 4.97 9.97a.749.749 0 0 0 .326 1.275.749.749 0 0 0 .734-.215L8 9.06l1.97 1.97a.749.749 0 0 0 1.275-.326.749.749 0 0 0-.215-.734L9.06 8l1.97-1.97a.749.749 0 0 0-.326-1.275.749.749 0 0 0-.734.215L8 6.94Z"
  }));
};
XFilledIcon.displayName = "XFilledIcon";

export { XFilledIcon as default };
